import { useState } from 'react'

import type { Row } from '@tanstack/react-table'

import RemoveIcon from '@/assets/icons/icon-trash.svg'

import type { SocialAccount } from '../../types'
import { AccountRemoveDialog } from './Dialogs/account-remove-dialog'

export interface SocialAccountActionsProps {
  row: Row<SocialAccount>
}

export const AccountAction = ({ row }: SocialAccountActionsProps) => {
  const [showRemoveDialog, setRemoveAccountDialog] = useState(false)

  const openRemoveDialog = () => {
    setRemoveAccountDialog(true)
  }

  return (
    <>
      <div className="float-right">
        <RemoveIcon
          width={18}
          height={18}
          onClick={openRemoveDialog}
          className="cursor-pointer text-danger-default"
        >
          Remove
        </RemoveIcon>
      </div>

      <AccountRemoveDialog
        row={row}
        setRemoveAccountDialog={setRemoveAccountDialog}
        showRemoveDialog={showRemoveDialog}
      />
    </>
  )
}
